import React, { PropTypes } from 'react';
import LostAdjustmentForm from './LostAdjustmentForm';
import axios from './../../../constants/axios';
import { SubmissionError } from 'redux-form';
import alert from 'alertify.js';

class LostAdjustment extends React.Component {

   saveLostAdjustment = (values) => {
      return axios.post('/lostAdjustment/saveLostAdjustment', values)
         .then((res) => {
            if (res.status === 201) {
               alert.success('Inventory Lost Created.');
               this.context.router.push('/presentStock');
            } else {
               alert.error('Something went unexpected. Call Rasel.');
            }
         })
         .catch((err) => {
            if (err.response.status === 422) {
               throw  new SubmissionError(err.response.data);
            } else {
               alert.error('Something not right. Rasel, where are you?');
            }
         });
   };


   render() {
      return (
         <div>
            <h3>Lost Adjustment Form</h3>
            <LostAdjustmentForm saveLostAdjustment={this.saveLostAdjustment} />
         </div>
      );
   }
}
LostAdjustment.contextTypes = {
   router: PropTypes.object
};
export default LostAdjustment;



/** WEBPACK FOOTER **
 ** ./src/components/StockManagement/LostAdjustment/LostAdjustment.js
 **/